import {
    ADD_AUDIENCES,
    AGENDATE_AUDIENCES,
    AGENDATE_AUDIENCES_SUCCESS,
    AGENDATE_AUDIENCES_ERROR,
    ANULATE_ACCUSED_RESULT,
    ANULATE_ACCUSED_RESULT_SUCCESS,
    ANULATE_ACCUSED_RESULT_ERROR,
    ANULATE_AUDIENCE,
    ANULATE_AUDIENCE_SUCCESS,
    ANULATE_AUDIENCE_ERROR,
    APPROVE_AUDIENCE,
    APPROVE_AUDIENCE_SUCCESS,
    APPROVE_AUDIENCE_ERROR,
    CANCEL_AUDIENCE,
    CANCEL_AUDIENCE_SUCCESS,
    CANCEL_AUDIENCE_ERROR,
    CLONE_AUDIENCE,
    CLONE_AUDIENCE_SUCCESS,
    CLONE_AUDIENCE_ERROR,
    DELETE_AUDIENCES,
    DELETE_AUDIENCES_SUCCESS,
    DELETE_AUDIENCES_ERROR,
    EDIT_AUDIENCES,
    FINALIZE_AUDIENCE,
    FINALIZE_AUDIENCE_SUCCESS,
    FINALIZE_AUDIENCE_ERROR,
    GET_AUDIENCE,
    GET_AUDIENCE_SUCCESS,
    GET_AUDIENCE_ERROR,
    LIST_AUDIENCES,
    LIST_AUDIENCES_SUCCESS,
    LIST_AUDIENCES_ERROR,
    REJECT_AUDIENCE,
    REJECT_AUDIENCE_SUCCESS,
    REJECT_AUDIENCE_ERROR,
    RESERVE_AUDIENCE,
    RESERVE_AUDIENCE_SUCCESS,
    RESERVE_AUDIENCE_ERROR,
    RESORTEAR_JUEZ,
    RESORTEAR_JUEZ_SUCCESS,
    RESORTEAR_JUEZ_ERROR,
    REVOKE_AUDIENCE,
    REVOKE_AUDIENCE_SUCCESS,
    REVOKE_AUDIENCE_ERROR,
    SAVE_ACCUSED_RESULT,
    SAVE_ACCUSED_RESULT_SUCCESS,
    SAVE_ACCUSED_RESULT_ERROR,
    SAVE_AUDIENCES,
    SAVE_AUDIENCES_SUCCESS,
    SAVE_AUDIENCES_ERROR,    
    UPDATE_ACCUSED,
    UPDATE_ACCUSED_SUCCESS,
    UPDATE_ACCUSED_ERROR,
    UPDATE_AUDIENCES,
    UPDATE_AUDIENCES_SUCCESS,
    UPDATE_AUDIENCES_ERROR, 
    UPDATE_OFIJU,
    UPDATE_OFIJU_SUCCESS,
    UPDATE_OFIJU_ERROR,
    UPDATE_OPERATOR,
    UPDATE_OPERATOR_SUCCESS,
    UPDATE_OPERATOR_ERROR,
    UPDATE_PROCEEDING,
    UPDATE_PROCEEDING_SUCCESS,
    UPDATE_PROCEEDING_ERROR,   
    UPDATE_PROSECUTOR,
    UPDATE_PROSECUTOR_SUCCESS,
    UPDATE_PROSECUTOR_ERROR,
    UPDATE_SALA,
    UPDATE_SALA_SUCCESS,
    UPDATE_SALA_ERROR,
    UPDATE_SCHEDULED_END,    
    UPDATE_SCHEDULED_END_SUCCESS,    
    UPDATE_SCHEDULED_END_ERROR,
    UPDATE_SESSION_URL,
    UPDATE_SESSION_URL_SUCCESS,
    UPDATE_SESSION_URL_ERROR,
    UPDATE_VICTIM,
    UPDATE_VICTIM_SUCCESS,
    UPDATE_VICTIM_ERROR,
    WORK_LIST_AUDIENCES,
    WORK_LIST_AUDIENCES_SUCCESS,
    WORK_LIST_AUDIENCES_ERROR,
} from '../types';

const STATUS_MAP = {
    REQUESTED:   { id: 1,  descripcion: 'Solicitud',    css: 'secondary' },
    APPROVED:    { id: 2,  descripcion: 'Aprobada',     css: 'warning'   },
    SCHEDULED:   { id: 3,  descripcion: 'Agendada',     css: 'primary'   },
    EFFECTIVE:   { id: 4,  descripcion: 'Efectiva',     css: 'success'   },
    HELD:        { id: 4,  descripcion: 'Efectiva',     css: 'success'   },
    RECONVERTED: { id: 5,  descripcion: 'Reconvertida', css: 'success'   },
    CONTINUITY:  { id: 6,  descripcion: 'Continuidad',  css: 'success'   },
    CONTINUATION:{ id: 6,  descripcion: 'Continuidad',  css: 'success'   },
    RESCHEDULED: { id: 7,  descripcion: 'Reprogramada', css: 'success'   },
    SUSPENDED:   { id: 8,  descripcion: 'Suspendida',   css: 'warning'   },
    CANCELLED:   { id: 9,  descripcion: 'Cancelada',    css: 'danger'    },
    REJECTED:    { id: 10, descripcion: 'Rechazada',    css: 'danger'    },
    ANNULLED:    { id: 11, descripcion: 'Anulada',      css: 'danger'    },
};

const normalizeAudience = (item) => ({
    actuacionList: [],
    anular: item.can_anulate || false,
    audienciaTipoList: (item.audience_types || []).map((desc, i) => ({ id: i, descripcion: desc })),
    caratula: item.case_title,
    estado: STATUS_MAP[item.status] || { id: 0, descripcion: item.status, css: 'secondary' },
    expediente: { 
        caratula: item.case_title,
        numero: item.file_number 
    },
    fechaSolicitud: item.request_date,
    fin: item.end_date,
    id: item.id,
    inicio: item.start_date,
    motivo: item.rejection_reason ? { descripcion: item.rejection_reason } : null,
    observacionRechazo: item.rejection_observation || null,
    ofiju: null,
    operador: null,
    privada: 0,
    sala: item.room ? { descripcion: item.room } : null,
    usuario: null,
    verActuaciones: item.has_hearing_minutes || false,
});

//Cada reducer tiene su propio state
const initialState = {
    actualPage: null,
    audienceLoading: false,
    audiences: null,
    audienceSelected: null,
    audiencesWorkList: null,
    audienceWork: null,
    error: null,
    errorSave: null,
    isEdit: false,
    isFirst: null,
    isLast: null,
    loading: false,
    loadingSave: false,
    total: null,
    totalPages: null,
    workListActualPage: null,
    workListIsFirst: null,
    workListIsLast: null,
    workListTotal: null,
    workListTotalPages: null,
}

export default function(state = initialState, action) {
    switch(action.type){        
         
        case ADD_AUDIENCES:
            return {
                ...state,
                audienceSelected: null,
                isEdit: false
            }            
        case AGENDATE_AUDIENCES:
        case ANULATE_ACCUSED_RESULT:
        case ANULATE_AUDIENCE:
        case APPROVE_AUDIENCE:
        case CANCEL_AUDIENCE:
        case FINALIZE_AUDIENCE:
        case REJECT_AUDIENCE:
        case RESERVE_AUDIENCE:
        case REVOKE_AUDIENCE:
        case UPDATE_ACCUSED:
        case UPDATE_OFIJU:
        case UPDATE_OPERATOR:
        case UPDATE_PROCEEDING:
        case UPDATE_PROSECUTOR:
        case UPDATE_SALA:
        case UPDATE_SCHEDULED_END:
        case UPDATE_SESSION_URL:
        case UPDATE_VICTIM:
            return {
                ...state,
                audienceLoading: true
            }
        case CLONE_AUDIENCE:  
        case LIST_AUDIENCES:
            return {
                ...state,
                loading: true,
                audiences: null,
                total: null,
                totalPages: null,
                actualPage: null,
                isFirst: null,
                isLast: null,
            }
        case WORK_LIST_AUDIENCES:
            return {
                ...state,
                loading: true
            }
        case DELETE_AUDIENCES:
        case SAVE_AUDIENCES:
            return {
                ...state,
                isEdit: false,
                loadingSave: true
            }
        case EDIT_AUDIENCES:
            return {
                ...state,
                audienceSelected: action.payload,
                isEdit: true
            }
        case GET_AUDIENCE:
            return {
                ...state,
                audienceLoading: true
            }
        case RESORTEAR_JUEZ:
            return {
                ...state,
                loading: true
            } 
        // No actualiza AudienceWork para que no se vuelva a renderizar porque cierra los modales
        case SAVE_ACCUSED_RESULT:
            return {
                ...state
            }
        case UPDATE_AUDIENCES:
            return {
                ...state,
                loadingSave: true
            }            
        case AGENDATE_AUDIENCES_ERROR:
        case APPROVE_AUDIENCE_ERROR:
        case CANCEL_AUDIENCE_ERROR:
        case FINALIZE_AUDIENCE_ERROR:
        case REJECT_AUDIENCE_ERROR:
        case RESERVE_AUDIENCE_ERROR:
        case REVOKE_AUDIENCE_ERROR:
        case SAVE_ACCUSED_RESULT_ERROR:
        case UPDATE_ACCUSED_ERROR:
        case UPDATE_OFIJU_ERROR:
        case UPDATE_OPERATOR_ERROR:
        case UPDATE_PROCEEDING_ERROR:
        case UPDATE_PROSECUTOR_ERROR:
        case UPDATE_SALA_ERROR:
        case UPDATE_SCHEDULED_END_ERROR:
        case UPDATE_SESSION_URL_ERROR:
        case UPDATE_VICTIM_ERROR:
            return {
                ...state,
                audienceLoading: false,
                error: action.payload
            }
        case ANULATE_ACCUSED_RESULT_ERROR:
        case ANULATE_AUDIENCE_ERROR:
        case CLONE_AUDIENCE_ERROR:
        case LIST_AUDIENCES_ERROR:
        case WORK_LIST_AUDIENCES_ERROR:
            return {
                ...state,
                error: action.payload,
                loading: false,
            }            
        case DELETE_AUDIENCES_ERROR:
        case SAVE_AUDIENCES_ERROR:
        case UPDATE_AUDIENCES_ERROR:
            return {
                ...state,
                errorSave: action.payload,
                loadingSave: false,
            }
        case GET_AUDIENCE_ERROR:
            return {
                ...state,
                audienceLoading: false,
                error: action.payload
            }
        case RESORTEAR_JUEZ_ERROR:
            return {
                ...state,
                error: action.payload,
                loading: false,
            }
            
        case AGENDATE_AUDIENCES_SUCCESS:
        case APPROVE_AUDIENCE_SUCCESS:
        case CANCEL_AUDIENCE_SUCCESS:
        case FINALIZE_AUDIENCE_SUCCESS:
        case REJECT_AUDIENCE_SUCCESS:
        case RESERVE_AUDIENCE_SUCCESS:
        case REVOKE_AUDIENCE_SUCCESS:
        case UPDATE_OFIJU_SUCCESS:
        case UPDATE_OPERATOR_SUCCESS:
        case UPDATE_PROCEEDING_SUCCESS:
        case UPDATE_PROSECUTOR_SUCCESS:
        case UPDATE_SALA_SUCCESS:
        case UPDATE_SCHEDULED_END_SUCCESS:
            return {
                ...state,
                audienceLoading: false,
                audienceWork: action.payload
            }
        case ANULATE_ACCUSED_RESULT_SUCCESS:
            return {
                ...state,
                audienceWork: action.payload,
                errorSave: null,
                loadingSave: false,
            }
        case ANULATE_AUDIENCE_SUCCESS:
        case UPDATE_AUDIENCES_SUCCESS:
            return {
                ...state,
                audiences: state.audiences.map(audience => 
                    audience.id === action.payload.id ? audience = action.payload : audience
                ),
                audienceSelected: null,
                errorSave: null,
                loadingSave: false,
            }
        case CLONE_AUDIENCE_SUCCESS:
            return {
                ...state,
                loading: false
            }
        case DELETE_AUDIENCES_SUCCESS:
            return {
                ...state,
                audiences: state.audiences.filter( audience => audience.id !== action.payload),
                errorSave: null,
                loadingSave: false,
            }
        case GET_AUDIENCE_SUCCESS:
            return {
                ...state,
                audienceLoading: false,
                audienceWork: action.payload
            }
        case LIST_AUDIENCES_SUCCESS:
            return {
                ...state,
                audiences: (action.payload.content || []).map(normalizeAudience),
                actualPage: action.payload.page,
                error: null,
                isFirst: action.payload.page === 0,
                isLast: action.payload.page >= action.payload.total_pages - 1,
                loading: false,
                total: action.payload.total_elements,
                totalPages: action.payload.total_pages,
                workListActualPage: action.payload.page,
                workListIsFirst: action.payload.page === 0,
                workListIsLast: action.payload.page >= action.payload.total_pages - 1,
                workListTotal: action.payload.total_elements,
                workListTotalPages: action.payload.total_pages,
            }                       
        case RESORTEAR_JUEZ_SUCCESS:
            return {
                ...state,
                audienceWork: { 
                    ...state.audienceWork,
                    audienciaJuezList: action.payload
                },
                error: null,
                loading: false,
            }
        case SAVE_ACCUSED_RESULT_SUCCESS:
            return {
                ...state,
                audienceWork: {
                    ...state.audienceWork,
                    imputadoList: state.audienceWork.imputadoList.map(el=>
                        el.id===action.payload.id
                            ?
                                action.payload
                            :
                                el
                    )
                }
            } 
        case SAVE_AUDIENCES_SUCCESS:
            return {
                ...state,
                errorSave: null,
                loadingSave: false,
            }            
        case UPDATE_ACCUSED_SUCCESS:
            return {
                ...state,
                audienceLoading: false,
                audienceWork: {
                    ...state.audienceWork,
                    imputadoList: state.audienceWork.imputadoList.map(accused => 
                        accused.id === action.payload.id ? accused = action.payload : accused
                    )
                }
            }
        case UPDATE_SESSION_URL_SUCCESS:
            return {
                ...state,
                audienceLoading: false,
                audienceWork: {
                    ...state.audienceWork,
                    sessionUrl: action.payload.sessionUrl
                }
            }
        case UPDATE_VICTIM_SUCCESS:
            return {
                ...state,
                audienceLoading: false,
                audienceWork: {
                    ...state.audienceWork,
                    victimaList: state.audienceWork.victimaList.map(victim => 
                        victim.id === action.payload.id ? victim = action.payload : victim
                    )
                }
            }
        case WORK_LIST_AUDIENCES_SUCCESS:
            return {
                ...state,
                audiencesWorkList: action.payload.audiences,
                error: null,
                loading: false,
                workListActualPage: action.payload.page,
                workListIsFirst: action.payload.isFirst,
                workListIsLast: action.payload.isLast,
                workListTotal: action.payload.totalElements,
                workListTotalPages: action.payload.totalPages,
            }
        default:
            return state;
    }
}
